import settingsLanguage from './settingsLanguage.json';
import giftcard from './giftcard.json';
import gridButtons from './gridButtons.json';
import switchUser from './switchUser.json';

export const fo = {
  settingsLanguage,
  giftcard,
  gridButtons,
  switchUser,
};
